<template>
  <div class="details-wrapper">
    <div class="training-details">
      <h3>Selected Training</h3>
      <ul>
        <li><b>Training:</b> {{ title }}<br /></li>
        <li><b>Session One Date: </b>{{ sessionOne }}<br /></li>
        <li><b>Session Two Date: </b>{{ sessionTwo }}<br /></li>
        <li><b>Session Three Date: </b>{{ sessionThree }}<br /></li>
        <li><b>Time: </b>{{ time }}<br /></li>
        <li><b>Location: </b>{{ location }}</li>
    </ul>
    </div>

    <!-- *** DETAILS - NO EDIT *** -->

    <div class="no-edit" v-if="!editRegistration">
      <div class="main-form">
        <h3>Registered Participant's Information</h3>
        <ul>
          <li><b>Name:</b> {{ participantFirstName }} {{ participantLastName }}</li>
          <li><b>Email:</b> {{ participantEmail }}</li>
          <li><b>Phone:</b> {{ participantPhone }}</li>
          <li><b>Building: </b>{{ building }}</li>
          <li><b>Has Guide: </b>{{ hasGuide }}</li>
          <li><b>Registered by: </b><span v-if="registeredBy === 'self'">Self</span><span v-if="registeredBy === 'other'">Someone Else</span></li>
        </ul>
      </div>
      <div class="main-form" v-if="registeredBy === 'other'">
        <h3>Contact Information</h3>
        <ul>
          <li><b>Name:</b> {{ registrantFirstName }} {{ registrantLastName }}</li>
          <li><b>Email:</b> {{ registrantEmail }}</li>
          <li><b>Phone:</b> {{ registrantPhone }}</li>
        </ul>
      </div>
      <div class="main-form">
        <h3>Billing Information</h3>
        <ul>
          <li><b>Billing Address: </b><br /><li>{{ district }}<br />{{ billingAddress }}<br />{{ billingCity }}, {{ billingState }} {{ billingZip }}</li>
        </ul>
      </div>
      <button class="button" @click.prevent="editReg">Edit Registration</button>
      <button class="button secondary" @click.prevent="returnToRegistrations">Return to Training Registrations</button>
      <button class="button secondary red-button" @click.prevent="toggleCancel" v-if="!showCancel">Cancel Registration</button>
      <div class="overlay" v-if="showCancel">
        <div class="cancel-dialogue" v-if="showCancel">
          <p>Are you sure you would like to cancel this registration?</p>
          <button class="button" @click.prevent="cancelRegistration">Yes</button>
          <button class="button" @click.prevent="toggleCancel">No</button>
        </div>
      </div>
    </div>

    <!-- *** DETAILS - EDIT AREA *** -->

    <form @submit.prevent="updateRegistration" v-if="editRegistration">
        <div class="main-form">
          <h3>Registered Participant's Information</h3>
          <div class="form-element">
            <p><b>Registered by:</b></p>
            <label for="self">Myself</label>
            <input type="radio" id="self" value="self" v-model="registeredBy" disabled>
            <label for="other" style="margin-left: 15px;">Someone Else</label>
            <input type="radio" id="other" value="other" v-model="registeredBy" disabled>
          </div>
          <div class="form-element">
            <label for="participantFirstName">First Name</label>
            <input type="text" name="participantFirstName" v-model="participantFirstName" v-validate="'required'" :class="{ 'input': true, 'border border-danger': errors.has('participantFirstName') }" :disabled="registeredBy == 'self'">
            <span v-show="errors.has('participantFirstName')" class="text-danger">{{ errors.first('participantFirstName') }}</span>
          </div>
          <div class="form-element">
            <label for="participantLastName">Last Name</label>
            <input type="text" name="participantLastName" v-model="participantLastName" v-validate="'required'" :class="{ 'input': true, 'border border-danger': errors.has('participantLastName') }" :disabled="registeredBy == 'self'">
            <span v-show="errors.has('participantLastName')" class="text-danger">{{ errors.first('participantLastName') }}</span>
          </div>
          <div class="form-element">
            <label for="participantEmail">Email Address</label>
            <input type="email" name="participantEmail" v-model="participantEmail" v-validate="'required'" :class="{ 'input': true, 'border border-danger': errors.has('participantEmail') }" :disabled="registeredBy == 'self'">
            <span v-show="errors.has('participantEmail')" class="text-danger">{{ errors.first('participantEmail') }}</span>
          </div>
          <div class="form-element">
            <label for="participantPhone">Phone Number</label>
            <input type="text" name="participantPhone" v-model="participantPhone">
          </div>
          <div class="form-element">
            <label for="building">Building</label>
            <input type="text" name="building" v-model="building" v-validate="'required'" :class="{ 'input': true, 'border border-danger': errors.has('building') }">
            <span v-show="errors.has('building')" class="text-danger">{{ errors.first('building') }}</span>
          </div>
          <div class="form-element">
            <p>Does participant have a current/updated teacher guide?</p>
            <label for="yes">Yes</label>
            <input type="radio" id="yes" value="Yes" v-model="hasGuide">
            <label for="no" style="margin-left: 15px;">No</label>
            <input type="radio" id="no" value="No" v-model="hasGuide">
          </div>
        </div>
        <div class="main-form" v-if="registeredBy === 'other'">
          <h3>Contact Information</h3>
          <div class="form-element">
            <label for="registrantFirstName">First Name</label>
            <input type="text" name="registrantFirstName" v-model="registrantFirstName" v-validate="'required'" :class="{ 'input': true, 'border border-danger': errors.has('registrantFirstName') }" v-if="editRegistration" disabled>
            <span v-show="errors.has('registrantFirstName')" class="text-danger">{{ errors.first('registrantFirstName') }}</span>
          </div>
          <div class="form-element">
            <label for="registrantLastName">Last Name</label>
            <input type="text" name="registrantLastName" v-model="registrantLastName" v-validate="'required'" :class="{ 'input': true, 'border border-danger': errors.has('registrantLastName') }" disabled>
            <span v-show="errors.has('registrantLastName')" class="text-danger">{{ errors.first('registrantLastName') }}</span>
          </div>
          <div class="form-element">
            <label for="registrantEmail">Email Address</label>
            <input type="email" name="registrantEmail" v-model="registrantEmail" v-validate="'required'" :class="{ 'input': true, 'border border-danger': errors.has('registrantEmail') }" disabled>
            <span v-show="errors.has('registrantEmail')" class="text-danger">{{ errors.first('registrantEmail') }}</span>
          </div>
          <div class="form-element">
            <label for="registrantPhone">Phone Number</label>
            <input type="text" name="registrantPhone" v-model="registrantPhone" v-validate="'required'" :class="{ 'input': true, 'border border-danger': errors.has('registrantPhone') }">
            <span v-show="errors.has('registrantPhone')" class="text-danger">{{ errors.first('registrantPhoneregistrantPhone') }}</span>
          </div>
        </div>
        <div class="main-form">
          <h3>Billing Information</h3>
          <div class="form-element">
            <label for="district">School District</label>
            <input type="text" name="district" v-model="district" v-validate="'required'" :class="{ 'input': true, 'border border-danger': errors.has('district') }" disabled>
            <span v-show="errors.has('district')" class="text-danger">{{ errors.first('district') }}</span>
          </div>
          <div class="form-element">
            <label for="purchaseOrder">Purchase Order Number</label>
            <input type="text" id="purchaseOrder" v-model="purchaseOrder">
          </div>
          <div class="form-element">
            <label for="building">Billing Address</label>
            <input type="text" name="billingAddress" v-model="billingAddress" v-validate="'required'" :class="{ 'input': true, 'border border-danger': errors.has('billingAddress') }">
            <span v-show="errors.has('billingAddress')" class="text-danger">{{ errors.first('billingAddress') }}</span>
          </div>
          <div class="form-element">
            <label for="building">Billing City</label>
            <input type="text" name="billingCity" v-model="billingCity" v-validate="'required'" :class="{ 'input': true, 'border border-danger': errors.has('billingCity') }">
            <span v-show="errors.has('billingCity')" class="text-danger">{{ errors.first('billingCity') }}</span>
          </div>
          <div class="form-element">
            <label for="building">Billing State</label>
            <input type="text" name="billingState" v-model="billingState" v-validate="'required'" :class="{ 'input': true, 'border border-danger': errors.has('billingState') }">
            <span v-show="errors.has('billingState')" class="text-danger">{{ errors.first('billingState') }}</span>
          </div>
          <div class="form-element">
            <label for="building">Billing Zip</label>
            <input type="text" name="billingZip" v-model="billingZip" v-validate="'required'" :class="{ 'input': true, 'border border-danger': errors.has('billingZip') }">
            <span v-show="errors.has('billingZip')" class="text-danger">{{ errors.first('billingZip') }}</span>
          </div>

          <div class="buttons-container">
            <button class="button" type="submit">Update Registration</button>
            <!-- <button class="button" @click.prevent="submitRegistration" :disabled="!acknowledge">Submit Registration</button> -->
            <!-- <button class="button" @click.prevent="submitRegistrationTest">Submit Registration</button> -->
            <button class="button secondary" @click.prevent="cancelRegEdit">Cancel Edit</button>
            <button class="button secondary" @click.prevent="returnToRegistrations">Return to Training Registrations</button>
          </div>
          <p>*Invoices will be sent out after the first session for Teacher Cohort Trainings.</p>
        </div>
    </form>
  </div>
</template>

<script>
const fb = require('./../../firebase/firebase')
import { mapState } from 'vuex'
//import moment from 'moment'
export default {
  data() {
    return {
      showCancel: false,
      editRegistration: false,
      title: '',
      sessionOne: '',
      sessionTwo: '',
      sessionThree: '',
      time: '',
      location: '',
      participantFirstName: '',
      participantLastName: '',
      participantEmail: '',
      participantPhone: '',
      hasGuide: '',
      registeredBy: '',
      registrantFirstName: '',
      registrantLastName: '',
      registrantEmail: '',
      registrantPhone: '',
      district: '',
      building: '',
      billingAddress: '',
      billingCity: '',
      billingState: '',
      billingZip: '',
      purchaseOrder: '',
      active: true,
      dateSubmitted: ''
    }
  },
  computed: {
    ...mapState([ 'registrationToEdit' ])
  },
  methods: {
    fetchRegistration() {
      fb.trainingRegistrationsCollection.doc(this.registrationToEdit).get().then((doc) => {
        if (doc.exists) {
          this.title = doc.data().title
          this.sessionOne = doc.data().sessionOne
          this.sessionTwo = doc.data().sessionTwo
          this.sessionThree = doc.data().sessionThree
          this.time = doc.data().time
          this.location = doc.data().location
          this.participantFirstName = doc.data().participantFirstName
          this.participantLastName = doc.data().participantLastName
          this.participantEmail = doc.data().participantEmail
          this.participantPhone = doc.data().participantPhone
          this.hasGuide = doc.data().hasGuide
          this.registeredBy = doc.data().registeredBy
          this.registrantFirstName = doc.data().registrantFirstName
          this.registrantLastName = doc.data().registrantLastName
          this.registrantEmail = doc.data().registrantEmail
          this.registrantPhone = doc.data().registrantPhone
          this.district = doc.data().district
          this.building = doc.data().building
          this.billingAddress = doc.data().billingAddress
          this.billingCity = doc.data().billingCity
          this.billingState = doc.data().billingState
          this.billingZip = doc.data().billingZip
          this.purchaseOrder = doc.data().purchaseOrder
          this.acknowledge = doc.data().acknowledge
          this.active = doc.data().active
          this.dateSubmitted = doc.data().dateSubmitted
        } else {
          console.log('No such registration.')
        }
      }).catch((err) => {
        console.log('Error: ', err)
      })
    },
    returnToRegistrations() {
      this.$store.commit('SET_REGISTRATION_TO_EDIT', null)
      this.$store.commit('SET_ADMIN_WHICH_COMPONENT', 'trainingDashboard')
    },
    editReg() {
      this.editRegistration = true
    },
    cancelRegEdit() {
      this.editRegistration = false
    },
    updateRegistration() {
      fb.trainingRegistrationsCollection.doc(this.registrationToEdit).update({
        participantFirstName: this.participantFirstName,
        participantLastName: this.participantLastName,
        participantEmail: this.participantEmail,
        participantPhone: this.participantPhone,
        hasGuide: this.hasGuide,
        registrantPhone: this.registrantPhone,
        building: this.building,
        billingAddress: this.billingAddress,
        billingCity: this.billingCity,
        billingState: this.billingState,
        billingZip: this.billingZip,
        purchaseOrder: this.purchaseOrder,
        active: true,
        dateUpdated: new Date()
      }).then(() => {
        console.log('Registration Updated!')
      }).catch((err) => {
        console.log('Error updating registration: ', err)
      })
    },
    toggleCancel() {
      this.showCancel = !this.showCancel
    },
    cancelRegistration() {
      fb.trainingRegistrationsCollection.doc(this.registrationToEdit).update({
        active: false,
        dateUpdated: new Date()
      }).then(() => {
        console.log('Registration Cancelled!')
        this.$store.commit('SET_REGISTRATION_TO_EDIT', null)
        this.$store.commit('SET_ADMIN_WHICH_COMPONENT', 'trainingDashboard')
      }).catch((err) => {
        console.log('Error updating registration: ', err)
      })
    }
  },
  mounted() {
    this.fetchRegistration()
  }
}
</script>

<style lang="css" scoped>
.main-form {
  border: 2px solid #cecece;
  background: #f7f7f7;
  width: 60%;
  margin: 20px;
  padding: 20px;
  border-radius: 5px;
  margin-left: auto;
  margin-right: auto;
  vertical-align: top;
}
.form-element {
  text-align: left;
  margin-bottom: 20px;
}
.main-form h3 {
  margin-bottom: 20px;
}
input {
  width: 100%;
  padding: 12px 20px;
  border: 1px solid #cecece;
  border-radius: 5px;
}
input[type="radio"], input[type="checkbox"] {
  width: auto;
}
button:disabled {
  background-color: #888;
  cursor: not-allowed;
}
input[type='checkbox']{
  width: 20px !important;
  height: 20px !important;
  margin: 5px;
  box-shadow: none;
  font-size: 2em;
  transform: translateY(.1em);
}
input[type='radio']{
  width: 20px !important;
  height: 20px !important;
  margin: 5px;
  box-shadow: none;
  font-size: 2em;
  transform: translateY(.1em);
}
.text-danger {
  color: red;
  font-size: .75em;
}
.border-danger {
  border: 1px solid red;
}
.training-details {
  border: 2px solid #cecece;
  background: #f7f7f7;
  width: 60%;
  margin: 20px;
  padding: 10px 15px;
  border-radius: 5px;
  margin-left: auto;
  margin-right: auto;
  text-align: left;
}
h3 {
  text-align: center;
  border-bottom: 1px solid #cecece;
  padding-bottom: 10px;
}
ul {
  /* display: grid;
  grid-template-columns: auto auto; */
  list-style: none;
  text-align: left;
}
.red-button {
  border: 2px solid red;
  color: red;
  background: white;
}
.red-button:hover,
.red-button:active,
.red-button:focus {
  background-color: #fff !important;
  color: darkRed;
  border: 2px solid darkRed;
}
.cancel-dialogue {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  -ms-transform: translate(-50%,-50%);
  border: 2px solid #cecece;
  max-width: fit-content;
  background: white;
  padding: 20px;
  text-align: center;
  margin: 20px auto;
}
.overlay {
  position: fixed; /* Sit on top of the page content */
  width: 100%; /* Full width (cover the whole page) */
  height: 100%; /* Full height (cover the whole page) */
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0,0,0,0.5); /* Black background with opacity */
  z-index: 2; /* Specify a stack order in case you're using a different order for other elements */
  cursor: pointer; /* Add a pointer on hover */
}
</style>
